import { render, staticRenderFns } from "./customCenter.vue?vue&type=template&id=7819f97e&scoped=true&"
import script from "./customCenter.vue?vue&type=script&lang=js&"
export * from "./customCenter.vue?vue&type=script&lang=js&"
import style0 from "./customCenter.vue?vue&type=style&index=0&id=7819f97e&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7819f97e",
  null
  
)

export default component.exports